/**
 * Supposedly pure css IOS Toggle.
 * Does not work if you refresh the elements of the page vis JS
 *
 * This super hacky solution fixes that
 *
 **/
e.ios_toggle = {
	init : function(){
		this._add_css_rules();
		$( 'body' ).on( 'click', 'input.toggle', this._update_classes );
	},


	_add_css_rules : function(){
		e.fn.add_global_css_rule( 'label.checked:before', 'width: 50px !important;' );
		e.fn.add_global_css_rule( 'label.checked:before', 'background: #08c169 !important;' );
		e.fn.add_global_css_rule( 'label.checked:after', 'left: 20px !important;' );
		e.fn.add_global_css_rule( 'label.checked:after', 'box-shadow: inset 0 0 0 1px #08c169, 0 2px 4px rgba(0, 0, 0, 0.2) !important;' );
		e.fn.add_global_css_rule( 'label.unchecked:before', 'width: 30px !important;' );
		e.fn.add_global_css_rule( 'label.unchecked:before', 'background: rgba(17, 188, 191, 0) !important;' );
		e.fn.add_global_css_rule( 'label.unchecked:after', 'left: 0 !important;' );
		e.fn.add_global_css_rule( 'label.unchecked:after', ' box-shadow:inset 0 0 0 1px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.2) !important;' );
	},

	_update_classes : function(){
		var toggle = $( this );
		var label  = $( "label[for='" + toggle.attr( 'id' ) + "']" );
		if( toggle.prop( 'checked' ) ){
			label.addClass( 'checked' );
			label.removeClass( 'unchecked' );
		} else {
			label.removeClass( 'checked' );
			label.addClass( 'unchecked' );
		}
	}

};